import K from '../constants';
import restHelpers from '../helpers/restHelper';

const getAllFn = () => restHelpers.withBearer.get(`${K.API_URL}/cars/lock-beat`, {});

const updateLockbeatFn = (imei, lat, lon, blocked) => restHelpers.withBearer.put(`${K.API_URL}/cars/${imei}/lock-beat`, { data: { lat, lon, blocked } });

export default {
  getAll: getAllFn,
  updateLockbeat: updateLockbeatFn
};



// WEBPACK FOOTER //
// ./src/services/lockbeat.js